import React, { useState, useEffect } from 'react';
import { Cascader } from 'antd';
import apis from '@/apis';

// level表示展示列数，从1开始

function SelectorHrDepart(props) {
  let { value, onChange, level, changeOnSelect = true, ..._props } = props;
  value = value && value.length > 0 && JSON.parse(value[value.length - 1]);

  const [treeData, setTreeData] = useState([]);

  useEffect(() => {
    let mounted = true;
    // 父组织code  注意，京东集团根级编码为00000000
    apis.queryOrganization('00000000').then((res) => {
      if (!mounted) return;
      const dataFormBackEnd = res.data.organizationTree.map((item) => transformResult(item, '/00000000', '', level));
      setTreeData(dataFormBackEnd);
    });

    return () => (mounted = false);
  }, [level]);

  // 加载部门树
  const onLoadData = (treeNode) => {
    const targetNode = treeNode[treeNode.length - 1];
    if (targetNode.children && targetNode.children.length > 0) return;
    targetNode.loading = true;

    const { id, titlePath, rawId } = targetNode;
    return apis.queryOrganization(rawId).then((res) => {
      targetNode.loading = false;
      const dataFormBackEnd = res.data.organizationTree.map((item) => transformResult(item, id, titlePath, level));
      targetNode.children = dataFormBackEnd;
      setTreeData([...treeData]);
    });
  };

  function displayRender(label) {
    return <span title={label.join('/')}>{label.join('/')}</span>;
  }

  return (
    <>
      <Cascader
        className="select-tree-organization"
        placeholder="请选择部门"
        changeOnSelect={changeOnSelect}
        style={{ width: '100%' }}
        {..._props}
        // expandTrigger="hover"
        onChange={onChange}
        loadData={onLoadData}
        options={treeData}
        value={value && value.name && value.name.split('-')}
        displayRender={displayRender}
        dropdownRender={(data) => <div className="select-tree-drop-down">{data}</div>}
        allowClear
      />
      <div id="aaaa"></div>
    </>
  );
}

function transformResult(item, pId, titlePath, level) {
  return {
    rawId: item.organizationId,
    id: `${pId}/${item.organizationId}`,
    pId: pId,
    value: JSON.stringify({
      id: item.fullOrganizationPath,
      name: item.fullOrganizationName,
    }),
    label: item.name,
    isLeaf: !!item.isLeaf || (!!level && Number(item.level) >= level),
    titlePath: titlePath ? `${titlePath}-${item.name}` : item.name,
  };
}

export default SelectorHrDepart;
